import { store } from "../../redux/store";
import { normalizeArray } from "../arrays";
import { DYNAMIC_PAGE_TEMPLATES, CONTENT_SITE_PAGE_TEMPLATES } from "./templates";

const getDynamicPageBasePaths = () => {
    const dynamicPagesData = store.getState().dynamicPagesData;
    const paths = {};

    const pageTemplates = { ...DYNAMIC_PAGE_TEMPLATES, ...CONTENT_SITE_PAGE_TEMPLATES };

    for (const [key, template] of Object.entries(pageTemplates)) {
        const templates = normalizeArray(template);

        for (const t of templates) {
            if (dynamicPagesData[t]) {
                paths[key] = dynamicPagesData[t];
                break;
            }
        }
    }

    return paths;
};

// Resolved on every call: the dynamic pages arrive in the store after the app has loaded, and
// differ per shop, so a value computed at import time is empty on a first visit (or stale from
// the previously visited shop, restored from localStorage)
export const getDynamicPagePaths = () => getDynamicPageBasePaths();

export const DYNAMIC_PAGE_QUERY_KEYS = {
    PRODUCT_OVERVIEW: "category",
    PRODUCT_DETAIL: "product",
};

export const STATIC_PAGE_PATHS = {
    // HOME is intentionally absent: it is the current site's base and resolved dynamically
    // in getStaticPageLink (utils/links.js).
    CART: "/cart",
    CHECKOUT: "/checkout",
    // The remaining flone "other" pages, served by their Magnolia twins under pages/magnolia
    // so they get the shop's header/footer from BaseLayout instead of flone's LayoutOne.
    COMPARE: "/compare",
    WISHLIST: "/wishlist",
    LOGIN_REGISTER: "/login-register",
    MY_ACCOUNT: "/my-account",
};
